/**
 * 探测 localStorage 可用性
 * @param {Boolean} useLocalStorage 是否在客户端环境
 */
var detectLocalStorage = function detectLocalStorage(useLocalStorage) {
  try {
    useLocalStorage && localStorage.getItem('try');
  } catch (e) {
    useLocalStorage = false;
  }

  return useLocalStorage;
};

export default detectLocalStorage;